import Axios from '@/plugins/Axios';
import { PromoList } from '@/types';
import { AxiosResponse } from 'axios';

const endpoint = '/promo';

const promoApi = {
  getPromoList: (promoCode: string) => {
    return Axios().get<[PromoList] | []>(`${endpoint}?code=${promoCode}`);
  },
};

export default promoApi;
